<template>
  <div>
    <Header :drawer="$store.state.drawer"></Header>
    <Sidebar :drawer="$store.state.drawer"></Sidebar>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-content>
      <v-container>
        <v-card>
          <v-card-title class="text-left font-weight-bold title-login"
            >VUNET Application Form</v-card-title
          >
          <v-form v-model="valid">
            <v-container style="padding: 20px">
              <v-row class="justify-left">
                <v-col cols="12" md="5" sm="5">
                  <v-text-field
                    dense
                    readonly
                    v-model="email"
                    :rules="emailRules"
                    label="E-mail*"
                    required
                    prepend-inner-icon="mdi-lock"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col cols="12" md="4" sm="4">
                  <v-text-field
                    dense
                    label="First Name*"
                    v-model="fname"
                    :rules="[(v) => !!v || 'required']"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" sm="4">
                  <v-text-field
                    dense
                    label="Middle Name"
                    v-model="mname"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" sm="4">
                  <v-text-field
                    dense
                    :rules="[(v) => !!v || 'required']"
                    label="Last Name*"
                    v-model="lname"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col cols="12" md="4" sm="4">
                  <v-text-field
                    dense
                    readonly
                    :rules="[(v) => !!v || 'required']"
                    label="Mobile No*"
                    v-model="mobno"
                    prepend-inner-icon="mdi-lock"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" sm="4">
                  <v-menu
                    ref="menu1"
                    v-model="menu1"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        dense
                        :rules="[(v) => !!v || 'required']"
                        v-model="dateFormatted"
                        label="Date of Birth* DD/MM/YYYY"
                        hint="DD/MM/YYYY format"
                        persistent-hint
                        prepend-icon="mdi-calendar"
                        v-bind="attrs"
                        @blur="date = parseDate(dateFormatted)"
                        @change="validateDOB()"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="date"
                      no-title
                      @input="menu1 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="4" sm="4">
                  <v-select
                    dense
                    :rules="[(v) => !!v || 'required']"
                    v-model="selectedGender"
                    :items="gender_list"
                    item-text="gender_name"
                    item-value="gender_id"
                    label="Gender*"
                    return-object
                  ></v-select>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col cols="12" md="4" sm="4">
                  <v-select
                    dense
                    :rules="[(v) => !!v || 'required']"
                    v-model="selectedCategory"
                    :items="category_list"
                    item-text="category_name"
                    item-value="category_id"
                    label="Category*"
                    return-object
                    @change="clearprogramfee()"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="8" sm="8">
                  <v-text-field
                    dense
                    :rules="[(v) => !!v || 'required']"
                    v-model="address"
                    name="input-7-4"
                    label="Address of Correspondence*"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col cols="12" md="4" sm="4">
                  <v-text-field
                    @keydown.space.prevent
                    dense
                    :rules="[(v) => !!v || 'required']"
                    label="City/Town*"
                    v-model="citytwon"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" sm="4">
                  <v-select
                    dense
                    :rules="[(v) => !!v || 'required']"
                    v-model="selectedState"
                    :items="state_list"
                    item-text="state_name"
                    item-value="state_id"
                    label="State*"
                    return-object
                  ></v-select>
                </v-col>
                <v-col cols="12" md="4" sm="4">
                  <v-select
                    dense
                    :rules="[(v) => !!v || 'required']"
                    v-model="selectedCountry"
                    :items="country_list"
                    item-text="country_name"
                    item-value="country_id"
                    label="Country*"
                    return-object
                  ></v-select>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col cols="12" md="4" sm="4">
                  <v-text-field
                    dense
                    :rules="[(v) => !!v || 'required']"
                    label="Pin Code*"
                    v-model="pincode"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" sm="4">
                  <v-text-field
                    dense
                    :rules="phoneNorules"
                    maxlength="10"
                    counter="10"
                    label="Alternate Mobile Number"
                    type="number"
                    v-model="altmobileno"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" sm="4">
                  <v-text-field
                    dense
                    :rules="phoneNorules"
                    maxlength="10"
                    counter="10"
                    type="number"
                    label="Whatsup Number"
                    v-model="whatsupno"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12" sm="12">
                  <v-radio-group
                    class="ml-2"
                    v-model="entrancetest"
                    :rules="[(v) => !!v || 'required']"
                    required
                  >
                    <v-row>
                      <v-col cols="12" md="6" sm="6">
                        <!-- <template v-slot:label> -->
                        <div>
                          <strong
                            >Whether Appeared for any other similar / relevant
                            Entrance Test?*</strong
                          >
                        </div>
                        <!-- </template> -->
                      </v-col>
                      <v-col cols="12" md="3" sm="3">
                        <v-radio value="Yes">
                          <template v-slot:label>
                            <div><strong>Yes</strong></div>
                          </template>
                        </v-radio>
                      </v-col>
                      <v-col cols="12" md="3" sm="3">
                        <v-radio value="No">
                          <template v-slot:label>
                            <div><strong>No</strong></div>
                          </template>
                        </v-radio>
                      </v-col>
                    </v-row>
                  </v-radio-group>
                </v-col>
                <!-- <v-col cols="12" md="2" sm="2">
                           <v-radio value="Yes">
                           <template v-slot:label>
                             <div><strong>Yes</strong></div>
                           </template>
                           </v-radio>
                           
                           </v-col>
                           <v-col cols="12" md="2" sm="2">
                           <v-radio value="No">
                           <template v-slot:label>
                             <div><strong>No</strong></div>
                           </template>
                           </v-radio>
                           </v-col> -->
              </v-row>
              <v-row justify="center">
                <v-col cols="12" md="6" sm="6">
                  <v-text-field
                    v-if="entrancetest == 'Yes'"
                    dense
                    label="Entrance Test Details"
                    v-model="entrancetestdetails"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col cols="12" md="4" sm="4">
                  <v-select
                    dense
                    :rules="[(v) => !!v || 'required']"
                    required
                    v-model="selectExamdate"
                    :items="examdate_list"
                    item-text="date"
                    item-value="examdateid"
                    label="VUNET Exam Date*"
                    return-object
                    @change="
                      validateExamDate();
                    "
                  ></v-select>
                </v-col>
                <v-col cols="12" md="4" sm="4">
                  <v-select
                    :rules="[(v) => !!v || 'required']"
                    v-model="selectedProg"
                    :items="program_list"
                    item-text="program_name"
                    item-value="program_id"
                    label="Select Program/Course For VUNET*"
                    return-object
                    @change="findExamFee()"
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" md="4" sm="4">
                  <v-select
                    dense
                    :rules="[(v) => !!v || 'required']"
                    readonly
                    prepend-inner-icon="mdi-lock"
                    v-model="selectExamFee"
                    :items="examfee_list"
                    item-text="fee"
                    item-value="examfees_id"
                    label="VUNET Exam Fee in RS*"
                    return-object
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="8" sm="12">
                  <v-select
                    dense
                    :rules="[(v) => !!v || 'required']"
                    prepend-inner-icon="mdi-lock"
                    v-model="selectedTestCenter"
                    :items="test_center_list"
                    item-text="center_name"
                    item-value="center_id"
                    label="VUNET Exam Center*"
                    return-object
                  ></v-select>
                </v-col>
              </v-row>
              <v-row v-if="uploadphoto.isactive">
                <v-col cols="12" md="8" sm="8">
                  <div>
                    <h4 class="m-3">Upload Photograph</h4>
                  </div>
                  <v-card class="box">
                    <div class="flex">
                      <div></div>
                    </div>
                    <v-card-text>
                      <v-row justify="center">
                        <v-col cols="12" lg="4" sm="12">
                          <form>
                            <h3 for="my-file" style="font-weight-bold">
                              Upload your file here
                            </h3>
                            <div class="form-group">
                              <input
                                type="file"
                                id="my_file"
                                ref="my_file"
                                data-max-size="10kb"
                                accept=".jpg,.jpeg,.png"
                                @change="previewMultiImage1"
                                class="form-control-file mt-5"
                              />
                            </div>
                          </form>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          style="color: red; font-size: 16px"
                        >
                          <center>
                            photo should be in .jpg format only.photo Resolution
                            should be 200W*260H.photo size should be less than
                            or equal to 50KB
                          </center>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4" sm="4">
                  <div v-if="userphoto == null" class="border">
                    <span>Preview Here:</span>
                    <template v-if="preview_list1.length">
                      <div v-for="(item, index) in preview_list1" :key="index">
                        <v-card max-width="107" max-height="80">
                          <img
                            :src="item"
                            class="img"
                            style="width: 107px; height: 80px"
                            @click="zoophotoimg(userphoto)"
                          />
                        </v-card>
                        <p class="mb-0">
                          file name: {{ image_list[index].name }}
                        </p>
                        <p>size: {{ image_list[index].size / 1024 }}KB</p>
                      </div>
                    </template>
                  </div>
                  <div v-if="userphoto != null" class="border">
                    <span>Photo</span>
                    <v-card max-width="107" max-height="80">
                      <img
                        :src="userphoto"
                        class="img"
                        style="width: 107px; height: 80px"
                        @click="zoophotoimg(userphoto)"
                      />
                    </v-card>
                  </div>
                </v-col>
              </v-row>
              <v-dialog v-model="dialog_zooimg1" persistent max-width="800px">
                <v-card>
                  <v-card-title>
                    <span class="headline">Image Pre-View</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <img
                            class="rounded w-100 d-block imgs-preview"
                            :src="userphoto"
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="button-cancel" @click="dialog_zooimg1 = false"
                      >Close</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-row v-if="uploadsign.isactive">
                <v-col cols="12" md="8" sm="8">
                  <div>
                    <h4 class="m-2">Upload Signature</h4>
                  </div>
                  <v-card class="box">
                    <div class="flex">
                      <div></div>
                    </div>
                    <v-card-text>
                      <v-row justify="center">
                        <v-col cols="12" lg="4" sm="12">
                          <form>
                            <div class="form-group">
                              <h3 for="my-file" style="font-weight-bold">
                                Upload your file here
                              </h3>
                              <input
                                type="file"
                                id="sig_file"
                                ref="sig_file"
                                accept="image/jpeg"
                                @change="previewMultiImage"
                                class="form-control-file mt-5"
                              />
                            </div>
                          </form>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          style="color: red; font-size: 16px"
                        >
                          <center>
                            Signature should in .jpg/.jpeg format only.photo
                            resolution should be 100W*100H.Photosize should be
                            less than or equal to 50KB.
                          </center>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4" sm="4">
                  <div v-if="usersigphoto == null" class="border">
                    <p>Preview Here:</p>
                    <template v-if="preview_list.length">
                      <div v-for="(item, index) in preview_list" :key="index">
                        <v-card max-width="107" max-height="35">
                          <img
                            :src="item"
                            class="img"
                            style="width: 107px; height: 35px"
                          />
                        </v-card>
                        <p class="mb-0">
                          file name: {{ image_list[index].name }}
                        </p>
                        <p>size: {{ image_list[index].size / 1024 }}KB</p>
                      </div>
                    </template>
                  </div>
                  <div v-if="usersigphoto != null" class="border">
                    <span>Signature</span>
                    <v-card max-width="107" max-height="50">
                      <img
                        :src="usersigphoto"
                        class="img"
                        style="width: 107px; height: 50px"
                        @click="zooimg(usersigphoto)"
                      />
                    </v-card>
                  </div>
                </v-col>
              </v-row>
              <v-dialog v-model="dialog_zooimg" persistent max-width="800px">
                <v-card>
                  <v-card-title>
                    <span class="headline">Image Pre-View</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <img
                            class="rounded w-100 d-block imgs-preview"
                            :src="usersigphoto"
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="button-cancel" @click="dialog_zooimg = false"
                      >Close</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <!-- <v-row justify="center"  style="">
                        <v-col cols="12" md="12">
                           <v-checkbox
                              dense
                              required
                              v-model="notice"
                              label="I have noted down entered Email ID carefully"
                              value=""
                              hide-details
                              ></v-checkbox>
                        </v-col>
                     </v-row> -->
              <div class="d">
                <input
                  type="checkbox"
                  id="note"
                  name="note"
                  required
                  v-model="notice"
                />
                <label for="note" style="text-align: justify" class="ml-1">
                  I confirm that the above provided / selected information is
                  TRUE. I understand that the Email ID mentioned above will be
                  my username for the VUNET. I also understand that the
                  Vishwakarma University (VU), Pune will henceforth communicate
                  with me only on mentioned Email ID and / or Mobile Number.
                </label>
              </div>
              <br />
              <v-row justify="center">
                <v-btn
                  :disabled="!valid"
                  style="color: white"
                  class="mr-4 btn-color"
                  @click="studentApplication"
                >
                  Save
                </v-btn>
              </v-row>
            </v-container>
          </v-form>
        </v-card>
      </v-container>
    </v-content>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import moment from "moment";
import { format, parseISO } from "date-fns";
import axios from "axios";
import Header from "../shared/Header";
import Sidebar from "../shared/Sidebar";

export default {
  components: {
    Header: Header,
    Sidebar: Sidebar,
  },
  data: (vm) => ({
    overlay: false,
    dialog_zooimg: false,
    dialog_zooimg1: false,
    preview: null,
    image: null,
    preview_list: [],
    preview_list1: [],
    image_list: [],
    my_file: "",
    sig_file: "",
    date: new Date().toISOString().substr(0, 10),
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    menu1: false,
    menu2: false,
    valid: false,
    userphoto: null,
    usersigphoto: null,
    uploadphoto: "",
    uploadsign: "",
    selectExamdate: {},
    selectExamFee: {},
    selectedGender: {},
    selectedCategory: {},
    selectedState: {},
    selectedCountry: {},
    selectedTestCenter: {},
    country_list: [],
    state_list: [],
    program_list: [],
    test_center_list: [],
    gender_list: [],
    category_list: [],
    examdate_list: null,
    examfee_list: null,
    selectedProg: "",
    snackbar_msg: "",
    snackbar: false,
    show1: false,
    show2: false,
    notice: false,
    fname: "",
    mname: "",
    lname: "",
    mobno: "",
    color: "",
    pincode: "",
    citytwon: "",
    address: "",
    altmobileno: "",
    whatsupno: "",
    entrancetest: "",
    entrancetestdetails: "",
    org: null,

    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    //
    required: [(value) => !!value || "Required."],
    min: [(v) => v.length >= 8 || "Min 8 characters"],
    phoneNorules: [
      (v) =>
        !v ||
        (v.length <= 10 && v.length >= 10) ||
        "Please enter valid Phone No.",
    ],
  }),
  watch: {
    date(val) {
      this.dateFormatted = this.formatDate(this.date);
      //  let day1 = this.dateFormatted.getDay();
      // alert()
      console.log(this.date);
    },

    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },
  computed: {
    computedDateFormatted() {
      console.log("computed", this.formatDate(this.date));
      return this.formatDate(this.date);
    },
  },
  methods: {
    zoophotoimg(url_img) {
      // alert("zooimg"+url_img)
      this.userphoto = url_img;
      this.dialog_zooimg1 = true;
    },
    validateDOB() {
      var dateformat =
        /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/;
      //  if(this.dateFormatted.value.match(dateformat)){
      if (this.dateFormatted.length != 10) {
        this.showSnackbar("#b71c1c", "Please select DOB in MM/DD/YYYY format!");
        this.dateformat = "";
        this.date = "";
        return false;
      } else if (
        this.dateFormatted.substring(2, 3) !== "/" ||
        this.dateFormatted.substring(5, 6) !== "/"
      ) {
        this.showSnackbar("#b71c1c", "Please select DOB in MM/DD/YYYY format!");
        this.dateformat = "";
        this.date = "";
        return false;
      } else {
        return true;
      }
    },
    validateExamDate() {
      let today = new Date();
      var datestring = this.selectExamdate.date;
      let exdate = new Date(datestring);
      if (today < exdate) {
        this.getProgramDetails();
        this.getTestCenterDetails();
        return true;
      } else {
        this.selectExamdate = {};
        exdate = null;
        this.selectedProg = null;
        this.selectExamFee = null;
        this.selectedTestCenter = null;
        this.showSnackbar("#b71c1c", "Exam date is passed!");
        return false;
      }
    },
    getProgramDetails() {
      let data = {
        exam_date_id: this.selectExamdate.examdateid
      };
      axios
        .post("/Student/getProgramDetails", data)
        .then((res) => {
          if (res.data.msg == "200") {
            this.selectedProg = res.data.proglist[0];
            this.program_list = res.data.proglist;
            if(this.program_list != []){
              this.findExamFee()
            }
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {});
    },
    getTestCenterDetails() {
      let formatted_date = moment(this.selectExamdate.date).format("DD/MM/YYYY");
      let data = {
        date: formatted_date,
      };
      axios
        .post("/Student/getTestCenter", data)
        .then((res) => {
          if (res.data.msg == "200") {
            this.selectedTestCenter = res.data.test_center_list[0];
            this.test_center_list = res.data.test_center_list;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {});
    },
    zooimg(url_img) {
      // alert("zooimg"+url_img)
      this.usersigphoto = url_img;
      this.dialog_zooimg = true;
    },
    saveStudentImage() {
      let formData = new FormData();
      formData.append("studentImage", this.my_file);

      axios
        .post("/Student/saveStudentImage", formData)
        .then(function () {
          console.log("SUCCESS!!");
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
    },
    saveStudentSigImage() {
      let formData = new FormData();
      formData.append("studentSigImage", this.sig_file);

      axios
        .post("/Student/saveStudentSigImage", formData)
        .then(function () {
          console.log("SUCCESS!!");
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
    },
    validateImage(file) {
      let file1 = file;
      let file_size = file1.size;
      let file_name = file.name;
      let ext = file_name.split(".").pop();
      if (file_size > 50000) {
        return false;
      } else {
        if (ext == "jpeg" || ext == "jpg" || ext == "png") {
          return true;
        } else {
          return false;
        }
      }
    },
    previewMultiImage1: function (event) {
      this.my_file = this.$refs.my_file.files[0];
      if (this.validateImage(this.my_file)) {
        this.userphoto = null;
        var input = event.target;
        var count = input.files.length;
        var index = 0;
        if (input.files) {
          while (count--) {
            var reader = new FileReader();
            reader.onload = (e) => {
              this.preview_list1.push(e.target.result);
            };
            this.image_list.push(input.files[index]);
            reader.readAsDataURL(input.files[index]);
            index++;
          }
        }

        this.saveStudentImage();
      } else {
        //   this.showSnackbar("#b71c1c", "Please select image in given format!");
        (this.my_file = ""), alert("Please select file in given format!");
      }
    },

    previewMultiImage: function (event) {
      this.sig_file = this.$refs.sig_file.files[0];
      if (this.validateImage(this.sig_file)) {
        this.usersigphoto = null;
        var input = event.target;
        var count = input.files.length;
        var index = 0;
        if (input.files) {
          while (count--) {
            var reader = new FileReader();
            reader.onload = (e) => {
              this.preview_list.push(e.target.result);
            };
            this.image_list.push(input.files[index]);
            reader.readAsDataURL(input.files[index]);
            index++;
          }
        }

        this.saveStudentSigImage();
      } else {
        (this.sig_file = ""), alert("Please select file in given format!");
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    clearprogramfee() {
      this.selectedProg = "";
      this.examfee_list = null;
    },
    studentApplication() {
      //alert("Save application form");
      let data = {
        fname: this.fname,
        mname: this.mname,
        lname: this.lname,
        mobno: this.mobno,
        gender: this.selectedGender,
        category: this.selectedCategory,
        address: this.address,
        citytwon: this.citytwon,
        pincode: this.pincode,
        country: this.selectedCountry,
        alternatemobno: this.altmobileno,
        whatsupno: this.whatsupno,
        entrancetest: this.entrancetest,
        entrancetestdetails: this.entrancetestdetails,
        examfee: this.selectExamFee,
        state: this.selectedState,
        program: this.selectedProg,
        examdate: this.selectExamdate,
        notice: this.notice,
        dob: this.date,
        testcenter: this.selectedTestCenter
      };
      axios
        .post("/Student/studentApplication", data)
        .then((res) => {
          if (res.data.msg == "200") {
            //4CAF50
            // this.showSnackbar("#4CAF50", "Student Application Submitted "+res.data.applicationReason);
            // if (res.data.applicationReason != "Application Submitted Successfully!") {
            //     this.showSnackbar("#b71c1c", "Your application not submitted please contact College/University!");
            //     return
            // }
            // if (res.data.applicationReason == "Application updated for the applied exam!!") {
            //     this.showSnackbar("#b71c1c", "Your application not submitted please contact College/University!");
            //     return
            // }

            // this.showSnackbar("#4CAF50", res.data.applicationReason);
            if (res.data.flag == "YES") {
              // this.showSnackbar("#4CAF50", res.data.applicationReason);
              // alert(res.data.applicationReason)
              this.$swal(
                "",
                "Student " + res.data.applicationReason,
                "success"
              );
              //this.$router.push("/student/student-application-fees");
              this.$router.push({
                path: "/student/student-application-fees-form",
                query: { item: res.data.lapp },
              });
            }
            if (res.data.flag == "NO") {
              this.showSnackbar(
                "#b71c1c",
                "Your application not submitted please contact College/University!"
              );
            }

            //this.$router.push({ name: 'sign-up', target: "blank" })
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {
          // this.$router.push("/student/student-application-fees");
        });
    },
    findExamFee() {
      let data = {
        programid: this.selectedProg,
        categoryid: this.selectedCategory,
      };
      axios
        .post("/Student/findExamFee", data)
        .then((res) => {
          if (res.data.msg == "200") {
            //4CAF50
            console.log("res.data.examfees", res.data.examfees);
            this.selectExamFee = res.data.examfees[0];
            this.examfee_list = res.data.examfees;
            // this.showSnackbar("#b71c1c", "Successfully ...");
            //this.$router.push({ name: 'sign-up', target: "blank" })
            //this.$router.push("/");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {});
    },
  },

  mounted() {
    this.overlay = true;
    axios
      .post("/Student/studentInformation")
      .then((res) => {
        if (res.data.msg == "200") {
          console.log("PROGARM ")
          console.log(res.data.proglist);
          this.overlay = false;
          this.email = res.data.learner_info.email;
          this.fname = res.data.learner_info.firstname;
          this.mname = res.data.learner_info.middle_name;
          this.lname = res.data.learner_info.lastname;
          this.mobno = res.data.learner_info.mobilenumber;
          this.selectedGender = res.data.learner_info.lgender;
          this.gender_list = res.data.genderlist;
          this.selectedCategory = res.data.learner_info.lcategory;
          this.category_list = res.data.categorylist;
          this.address = res.data.learner_info.address;
          this.citytwon = res.data.learner_info.city_town;
          this.state_list = res.data.statelist;
          this.pincode = res.data.learner_info.pincode;
          this.selectedCountry = res.data.learner_info.lcountry;
          this.selectedState = res.data.learner_info.lstate;
          this.country_list = res.data.countrylist;
          this.altmobileno = res.data.learner_info.alternate_mobile_number;
          this.whatsupno = res.data.learner_info.whatsapp_number;
          this.entrancetest =
            res.data.learner_info.is_appeared_for_other_entrance_test;
          this.entrancetestdetails =
            res.data.learner_info.other_entrance_test_details;
          // this.program_list = res.data.proglist;
          this.examdate_list = res.data.examdates;
          this.uploadphoto = res.data.uploadphoto;
          this.uploadsign = res.data.uploadsign;
          this.userphoto = res.data.learner_info.photofile;
          this.usersigphoto = res.data.learner_info.sigphotofile;
          this.date = res.data.learner_info.dateofbirth;
        }
      })
      .catch((error) => {
        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
      })
      .finally(() => {
        this.overlay = false;
      });
  },
};
/*
   1.
   <span style="opacity:1" v-html="opt.option_value"></span>
   
   2.
   import {VueMathjax} from 'vue-mathjax'
   import MathLive from 'mathlive'
   export default {
     components: {
       'vue-mathjax': VueMathjax
     },
   
   3.
   updated: function () {	
           console.log("Inside updated");
           this.$nextTick(function () {
       MathLive.renderMathInDocument();	
     })
   	},
   */
</script>
<style scoped>
div.d {
  text-align: justify;
}
.title-login {
  text-align: left;
  font: normal normal bold 22px/29px Roboto;
  letter-spacing: 0px;
  color: #212529;
}
.note-details {
  margin-left: 210px;
}
.note-details1 {
  margin-left: 100px;
}
.imgs {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
  width: 150px;
  cursor: zoom-in;
}
.imgs-preview {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
  width: auto;
}
.btn-color {
  box-shadow: 0px 3px 12px #f05a2bbf;
  border-radius: 5px;
  padding: 6px 20px;
  background: linear-gradient(90deg, #f3442b 1%, #f6681b 35%, #f66a1a 100%);
  text-decoration: none;
  color: #fff;
  text-align: center;
  color: white;
}
@media only screen and (max-width: 600px) {
  .note-details {
    margin-left: 0px;
  }
  .col-md-6,
  .col-12 {
    padding: 2px;
  }
  .note-details1 {
    margin-left: 0px;
  }
}
</style>